/* eslint-disable no-undef */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable dot-notation */
const test = {
  android: navigator.userAgent.match(/Android/i),
  webOs: navigator.userAgent.match(/webOS/i),
  iPhone: navigator.userAgent.match(/iPhone/i),
  iPad: navigator.userAgent.match(/iPad/i),
  iPod: navigator.userAgent.match(/iPod/i),
  blackberry: navigator.userAgent.match(/BlackBerry/i),
  windowsPhone: navigator.userAgent.match(/Windows Phone/i)
}

const userAgent = () => (test.android || test.webOs || test.iPhone || test.iPad || test.ipod || test.blackberry || test.windowsPhone) ? true : false
const getFullUserAgent = () => navigator.userAgent
const isBrowser = {
  safari: /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)),
  firefox: typeof InstallTrigger !== 'undefined' && getFullUserAgent().indexOf('Firefox') !== -1
}

export {
  userAgent,
  getFullUserAgent,
  isBrowser
}
